import styled from 'styled-components';
import { Colors } from '../../colors';
export const TabsListStyle = { borderBottom: `1px solid ${Colors.GS400}`, marginBottom: 16 };
export const TabsItemStyle = { fontWeight: 600, paddingBottom: 6, whiteSpace: 'nowrap' };
export const LoaderContainer = styled.div `
  margin-top: 16px;
  display: flex;
  justify-content: center;
`;
